"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vatReturnResponse = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const ledger_1 = require("./ledger");
const treatment = ledger_1.taxSnapshot.shape.treatment;
const vatFigure = zod_1.z.object({ base: common_1.moneyString, tax: common_1.moneyString });
/**
 * ملخص إقرار القيمة المضافة لفترة — من سطور القيود المنشورة وأثرها الضريبى وحدها، لا من
 * جداول المستندات. `BLOCKED-TAX`: ملخص داخلى يساعد فى ملء الإقرار الرسمى، لا نموذجه.
 *
 * كل رقم يُتتبَّع إلى مستنداته: `documents` سطر لكل (قيد، بند) بمفتاح البند `rowKey`
 * وخانته `kind`، ومجموع مستندات الخانة يساويها.
 */
exports.vatReturnResponse = zod_1.z.object({
    companyId: common_1.uuid,
    from: common_1.isoDate,
    to: common_1.isoDate,
    sales: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        treatment,
        ratePercent: zod_1.z.string(),
        /** false للصفرى والمعفى وخارج النطاق — تُعرض منفصلة. */
        taxable: zod_1.z.boolean(),
        sales: vatFigure,
        creditNotes: vatFigure,
        debitNotes: vatFigure,
        /** المبيعات − الإشعارات الدائنة + الإشعارات المدينة. */
        net: vatFigure,
    })),
    purchases: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        treatment,
        ratePercent: zod_1.z.string(),
        recoverable: zod_1.z.boolean(),
        purchases: vatFigure,
    })),
    /** أثر ضريبى على قيود لا يُعرف موضعها فى الإقرار (يدوية مثلاً) — يُعرض ولا يدخل الصافى. */
    other: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        sourceType: zod_1.z.string(),
        treatment,
        ratePercent: zod_1.z.string(),
        credit: vatFigure,
        debit: vatFigure,
    })),
    documents: zod_1.z.array(zod_1.z.object({
        rowKey: zod_1.z.string(),
        kind: zod_1.z.enum(['sale', 'debit_note', 'credit_note', 'purchase', 'other']),
        journalId: common_1.uuid,
        journalNumber: zod_1.z.string().nullable(),
        postingDate: common_1.isoDate,
        /** نوع المستند — وللقيد العكسى نوع أصله. */
        sourceType: zod_1.z.string(),
        /** نوع القيد كما رُحّل (`reversal` للعكسى). */
        journalSourceType: zod_1.z.string(),
        sourceId: zod_1.z.string().nullable(),
        reference: zod_1.z.string().nullable(),
        /** بإشارة أثره على خانته: العكسى سالب. */
        base: common_1.moneyString,
        tax: common_1.moneyString,
    })),
    outputTax: common_1.moneyString,
    taxableSalesBase: common_1.moneyString,
    nonTaxableSalesBase: common_1.moneyString,
    purchasesBase: common_1.moneyString,
    recoverableInputTax: common_1.moneyString,
    nonRecoverableInputTax: common_1.moneyString,
    /** المخرجات − المدخلات القابلة للخصم: موجب مستحق للتوريد، سالب رصيد لصالح الشركة. */
    netTax: common_1.moneyString,
    position: zod_1.z.enum(['payable', 'refundable', 'nil']),
});
//# sourceMappingURL=tax-reports.js.map